import React from 'react';
import styled from 'styled-components';
import {
    Button as MuiButton,
    withStyles,
    Theme,
    ButtonProps as MuiButtonProps,
} from '@material-ui/core';
import { style as createThemeStyle } from '@material-ui/system';
import { ResponsiveValue } from 'styled-system';

const StyledPrimaryButton = withStyles((theme: Theme) => ({
    root: {
        border: 0,
        borderRadius: '2rem',
        boxShadow: 'none',
    },
    label: {
        marginTop: theme.spacing(-0.5),
    },
}))(MuiButton);

type Size = 'small' | 'medium' | 'large' | 'xlarge' | 'full';
type Density = 'regular' | 'compact';

type PrimaryButtonProps = Omit<MuiButtonProps, 'size'> & {
    size?: ResponsiveValue<Size>;
    density?: ResponsiveValue<Density>;
    component?: React.ElementType;
} & any;

const widthStyle = createThemeStyle({
    prop: 'themewidth',
    themeKey: 'buttonWidths',
    cssProperty: 'width',
});

const heightStyle = createThemeStyle({
    prop: 'themeheight',
    themeKey: 'buttonHeights',
    cssProperty: 'height',
});

const SSPrimaryButton = styled(StyledPrimaryButton)<{
    themewidth: ResponsiveValue<Size>;
    themeheight: ResponsiveValue<Density>;
}>`
    ${widthStyle}
    ${heightStyle}
`;

const PrimaryButton = ({
    color = 'primary',
    size = 'medium',
    density = 'regular',
    ...rest
}: PrimaryButtonProps) => (
    <SSPrimaryButton
        variant="contained"
        color={color}
        themeheight={density}
        themewidth={size}
        {...rest}
    />
);

export default PrimaryButton;
